import { Injectable } from '@angular/core';
import { UnitsSettings } from '../models/unitsSettings';
import { EventBroadcastService } from './event-broadcast.service';
import { ProtuneApiService } from './protune-api.service';
import { BehaviorSubject, Observable, Subject, of, share, shareReplay, switchMap, switchMapTo, tap } from 'rxjs';
import { UserPreferences } from '../models/user-preferences';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {

  preferences?: UserPreferences; 
  userPreferences$: Subject<UserPreferences> = new Subject();
  refresh$ = new Subject<void>();
  
  
  constructor(private eventBroadcastService: EventBroadcastService, private protuneApiService: ProtuneApiService) { }

  getUserPreferences() {
    if (this.preferences == null) {
      return this.protuneApiService
        .getUserPreferences()
        .pipe(
          shareReplay());
    }
    else {
      return of(this.preferences);
    }
  }

  refreshUserPreferences() {
    
  }

  setUserPreferences(preferences: UserPreferences) {
    this.preferences = preferences;

    this.userPreferences$.next(preferences);

    return this.protuneApiService.saveUserPreferences(preferences)
      .pipe(tap(()=> {
        this.eventBroadcastService.broadcastPreferencesUpdated(preferences);
      }));
  }
}
